<form name="targetForm">
    <header class="info-tile-alt heading-row">
        <div class="title-container">
            <h2>Employee Records</h2>
        </div>
        <div class="drawer-close" (click)="rightSideDrawerService.closeRightSideDrawer()"><i class="fas fa-times" aria-hidden="true"></i></div>
    </header>

    <section class="sideRight-body">
        <div class="record-heading">
            <h3>Export</h3>
        </div>
        <div class="download-block mb-2">
            <div class="rde-row">
                <div class="col-6">
                   <div class="download-box">
                    <div class="rde-row"   (click)="downloadSelected(-1)">
                        <div class="col-3 download-icon"><i class="fa fa-download"></i></div>
                        <div class="col-9">
                            <div class="download-rec">
                                <div class="download-text">
                                    All Records
                                </div>
                            </div>
                        </div>
                    </div>
                   </div>
                </div>
                <div class="col-6">
                    <div class="download-box">
                    <div class="rde-row" (click)="downloadTemplate()">
                        <div class="col-3 download-icon"><i class="fa fa-download"></i></div>
                        <div class="col-9">
                            <div class="download-rec" (click)="downloadTemplate()">
                                <div class="download-text">Employee Template</div>                
                            </div>
                        </div>
                    </div>
                </div>
                </div>
            </div>


            
            
              
        </div>
        <div *ngIf="employeeRecordsFiltererd" class="mt-2">
           <div class="record-block">
            <h4 class="record-heading">Export Previous versions</h4>
            <section class="table-generated-information">
                <ngx-datatable class="ei-generated-table primary-ngx-datatable-styling managedoc-datatable ei-record-table"
                               [rows]="employeeRecordsFiltererd"
                               [headerHeight]="45"
                               [rowHeight]="55"
                               [columnMode]="'force'">
                    <ngx-datatable-column [draggable]="false" prop="fileName" name="DOCUMENT NAME"></ngx-datatable-column>
                    <ngx-datatable-column [draggable]="false" prop="insertedOn" name="IMPORT DATE">
                        <ng-template let-row="row" ngx-datatable-cell-template>
                            <span *ngIf="row.insertedOn">
                                {{row.insertedOn | date: 'MMM dd, yyyy, h:mm a'}}
                            </span>       
                        </ng-template>                   
                    </ngx-datatable-column>
                    <ngx-datatable-column [draggable]="false" [width]="20">
                        <ng-template let-row="row" ngx-datatable-cell-template>
                            <button class="link-button" (click)="downloadSelected(row.fileId)">
                                <i class="fa fa-download"></i>
                            </button>
                        </ng-template>
                    </ngx-datatable-column>
                </ngx-datatable>
            </section>
                
           </div>
        </div>
    </section>
</form>